import { AppBarProps, DashboardComponent, MenuProps } from "react-admin";
import { ComponentType } from "react";
import { RouteObject } from 'react-router-dom';
import { getConfig } from "../config/app.config";


export interface AppExtension {
    onAppInit?(): void;
    getAppImage?:() => string;
    getAppBar?:() => ComponentType<AppBarProps>;
    getMenu?:() => ComponentType<MenuProps>;
    getRoutes?: () => RouteObject[];   
    getDefaultRoute?:() => string;
    getWelcomePage?:() => DashboardComponent;
}

export interface AppExtensionProvider {
    getAppExtension(): AppExtension;
}

class AppExtensionProviderRegistry {
    private static providers: Map<string, AppExtensionProvider> = new Map();
  
    static registerProvider(key: string, provider: AppExtensionProvider) {
      if (this.providers.has(key)) {
        console.log(`AppExtensionProvider with key ${key} is already registered.`);
        return;
      }
      this.providers.set(key, provider);
    }

    /**
     * Returns the default AppExtensionProvider based on the APP_PRODUCT env variable.
     * The AppExtensionProvider must register using the same key as the APP_PRODUCT env variable.
     */
    static getDefaultProvider(): AppExtensionProvider {
        let productKey:string = getConfig('VITE_APP_PRODUCT');

        const safeGet = (key: string): string | null => {
          if (typeof window === 'undefined') {
            return null;
          }
          try {
            return sessionStorage.getItem(key);
          } catch (err) {
            return null;
          }
        };

        const activeProduct: string | null = safeGet('activeAppProduct');
        const productOverride: string | null = safeGet('selectedEnvProduct');

        const candidateProducts = [
          activeProduct,
          productOverride,
          productKey
        ].filter((value): value is string => !!value && value !== 'undefined' && value !== 'null');

        for (const candidate of candidateProducts) {
          if (this.providers.has(candidate)) {
            productKey = candidate;
            break;
          }
        }

        return this.getProvider(productKey);
    }


    /**
     * By Deafult use getDefaultProvider @see getDefaultProvider which will use the APP_PRODUCT env variable to get the default AppProviderExtension
     * @param key returns a specific AppExtensionProvider based on the key the AppExtensionProvider was registered with
     * @returns 
     */
    static getProvider(key: string): AppExtensionProvider {
      const provider = this.providers.get(key);
      if (!provider) {
        console.log('getProvider: provider not found', key);
        console.log('providers', this.providers);
        throw new Error(`AppExtensionProvider with key ${key} is not registered.`);
      }
      return provider;
    }
  }
  
  export default AppExtensionProviderRegistry;
